import React, { Typography } from '@common-ui/ui';

const width = 640 / 1.25;
const height = 480 / 1.25;

export default function DisplayImage({ image, header }) {
  return (
    <div>
      <Typography variant="h5" className="workItem__header">
        {header}
      </Typography>
      <div className="workItem__imageContainer">
        <img alt="columbia info images" src={image} width={width} height={height} />
      </div>
    </div>
  );
}
